import apiClient from './api/apiClient';

export const getDashboardConfig = () => apiClient.get('/me/dashboard/config');
export const saveDashboardConfig = (config) => apiClient.put('/me/dashboard/config', config);
